<template>
  <modal @close="$emit('close')">
    <div slot="header">
      <h4>Reply to Customer Review</h4>
    </div>
    <div class="modal-body-scroll" slot="body">
      <div class="row review-job-info">
        <div class="col-md-12 text-center mb-3">
          <p>
            You are about to reply to the Customer Review shown below. Once you add your reply, it will be shared on the website.
          </p>
          <p v-if="rating.body.length > 300" :title="rating.body">{{ rating.body.slice(0,300) + ' ...' }}</p>
          <p v-else>{{ rating.body }}</p>
        </div>
        <div class="col-md-12 text-center review-container-reply mt-4">
          <div class="select-wrap">
            <div class="d-flex justify-content-between comment-heading pt-1 pr-1">
              <label>Reply</label>
              <span class="review-body-length" v-if="reply.length < 100">min {{ remainingCount }}</span>
            </div>
            <textarea class="form-control w-100 border-0 bg-transparent review-comment"
                      v-model="reply"
                      minlength="100"
                      style="min-height: 250px"
            />
          </div>
          <error-field :errors="errors" field="rating" />
          <div class="d-flex align-items-center mt-3">
            <button class="btn btn-primary modal-done w-full" @click="saveReply" :disabled="reply.length < 100 || loading">
              Reply
              <div class="ld ld-ball ld-flip" v-if="loading" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" />
  </modal>
</template>
<script>
import axios from 'axios';
import Errors from '../../../classes/Errors';
import Modal from '../../Modal.vue';

export default {
  components: { Modal },
  props: {
    rating: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    loading: false,
    reply: '',
    minCount: 100,
    remainingCount: 100,
    errors: new Errors(),
  }),
  methods: {
    countdown() {
      this.remainingCount = this.minCount - this.body.length;
    },
    saveReply() {
      axios
        .post(`/companies/ratings/${this.rating.id}`, { reply: this.reply })
        .then(() => {
          this.$emit('close');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
  },
};
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/jobs/modals/CompanyRatingReplyModal.vue